import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@beef/ui-kit';

// import classNames from 'classnames/bind';
import { MapSimpleBaloon } from '../MapSimpleBaloon';
import { Message } from '../Message';

/* import styles from './styles.pcss'; */
/* const cx = classNames.bind(styles); */

export function MapPointBaloon({ point, onClick /* , isMobile */, viewState }) {
  const { point_type: pointType } = point;
  return (
    <MapSimpleBaloon point={point}>
      <Message {...point} />
      <Button
        onClick={() => {
          onClick(true, { ...point, pointType }, viewState);
        }}
      >
        Забрать здесь
      </Button>
      {/* <button
        className={cx('ya-map__button', isMobile && 'mobile')}
        onClick={() => { onClick(true, { ...point, pointType }, viewState); }}
      >
        Забрать здесь
      </button> */}
    </MapSimpleBaloon>
  );
}

MapPointBaloon.defaultProps = {
  point: {},
  onClick: () => {},
};

MapPointBaloon.propTypes = {
  point: PropTypes.shape({
    address: PropTypes.string,
    opening: PropTypes.string,
    subway: PropTypes.shape({
      name: PropTypes.string,
      color: PropTypes.string,
    }),
    isMovement: PropTypes.bool,
    movement_date: PropTypes.string,
    movement_time: PropTypes.string,
    point_type: PropTypes.any,
  }),
  onClick: PropTypes.func,
  isMobile: PropTypes.bool,
  viewState: PropTypes.string,
};
